<template>
  <path
    d="M17 16.0002L13 12.0002V8.82017C14.35 8.33017 15.26 6.93017 14.93 5.36017C14.68 4.18017 13.7 3.24017 12.51 3.04017C10.63 2.73017 9 4.17017 9 6.00017C9 7.30017 9.84 8.40017 11 8.82017V12.0002L7 16.0002H4C3.45 16.0002 3 16.4502 3 17.0002V20.0002C3 20.5502 3.45 21.0002 4 21.0002H7C7.55 21.0002 8 20.5502 8 20.0002V17.9502L12 13.7502L16 17.9502V20.0002C16 20.5502 16.45 21.0002 17 21.0002H20C20.55 21.0002 21 20.5502 21 20.0002V17.0002C21 16.4502 20.55 16.0002 20 16.0002H17Z"
  />
</template>
